import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { StyledSpinnerWithLabel } from '@bingads-webui-campaign-react/shell-ui-common';
import UetTagsTreeNodeWithTooltip from './uet-tags-tree-node-with-tooltip';

const UetTagTreeNode = ({
  classes, node,
}) => {
  if (node.isPlaceholderNode) {
    if (node.isLoadingData) {
      return (
        <div className={classNames([classes.baseMenuItem,
        classes.rootNodeSpinnerContainer])}
        >
          <StyledSpinnerWithLabel label={node.Name} />
        </div>
      );
    }

    const rootPlaceholderNodeTextContainerClassName = classNames([
      'uet-tag-tree-node-place-holder',
      classes.textContainer,
      classes.placeholderTextContainer,
    ]);

    return (
      <div className={classes.baseMenuItem}>
        <span className={rootPlaceholderNodeTextContainerClassName}>
          {node.Name}
        </span>
      </div>
    );
  }

  return (
    <UetTagsTreeNodeWithTooltip
      classes={classes}
      node={node}
    />
  );
};

UetTagTreeNode.propTypes = {
  classes: PropTypes.shape({
    baseMenuItem: PropTypes.string.isRequired,
    textContainer: PropTypes.string.isRequired,
    placeholderTextContainer: PropTypes.string.isRequired,
    iconContainer: PropTypes.string.isRequired,
    rootNodeSpinnerContainer: PropTypes.string.isRequired,
    hiddenTooltip: PropTypes.string.isRequired,
  }).isRequired,
  node: PropTypes.shape({
    Id: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]).isRequired,
    Name: PropTypes.string.isRequired,
    entityType: PropTypes.string.isRequired,
    TrackingStatus: PropTypes.string,
    isSelected: PropTypes.bool,
    isPlaceholderNode: PropTypes.bool,
    isLoadingData: PropTypes.bool,
  }).isRequired,
};

export function UetTagTreeNodeChildRenderer(classes) {
  return node => (
    <UetTagTreeNode
      classes={classes}
      node={node}
    />
  );
}
